import {Injectable} from '@angular/core';
import {IContext} from '../models/context';
import {ISupplierContext} from '@context/models/supplier-context';
import {ActivatedRoute, ActivatedRouteSnapshot} from '@angular/router';
import {RouteContext} from '@context/route-context';

@Injectable()
export class RouteContextService {

  constructor() {}

  getContextFromRoute(route: ActivatedRoute): IContext {
    let context = {} as IContext;
    if (!route?.snapshot?.paramMap)
      return context;
    if (route.snapshot.paramMap.get('propertyId')) {
      context.PropertyRef = +route.snapshot.paramMap.get('propertyId');
    }
    if (route.snapshot.paramMap.get('estateId')) {
      context.EstateRef = +route.snapshot.paramMap.get('estateId');
    }
    if (route.snapshot.paramMap.get('unitId')) {
      context.UnitRef = +route.snapshot.paramMap.get('unitId');
    }
    if (route.snapshot.paramMap.get('clientId')) {
      context.UserEnteredClientRef = +route.snapshot.paramMap.get('clientId');
    }
    if (route.snapshot.paramMap.get('leaseId')) {
      context.LeaseRef = +route.snapshot.paramMap.get('leaseId');
    }
    if (route.snapshot.paramMap.get('headleaseId')) {
      context.HeadLeaseRef = +route.snapshot.paramMap.get('headleaseId');
    }
    if (route.snapshot.paramMap.get('vacantId')) {
      context.VacantRef = +route.snapshot.paramMap.get('vacantId');
    }
    if (route.snapshot.paramMap.get('managerId')) {
      context.ManagerCode = route.snapshot.paramMap.get('managerId');
    }
    if (route.snapshot.paramMap.get('debtorId')) {
      context.DebtorUri = +route.snapshot.paramMap.get('debtorId');
    }
    if (route.snapshot.paramMap.get('supplierId')) {
      context.SupplierRef = +route.snapshot.paramMap.get('supplierId');
    }
    if (route.snapshot.paramMap.get('creditorId')) {
      context.CreditorUri = +route.snapshot.paramMap.get('creditorId');
    }
    if (route.snapshot.paramMap.get('tenantId')) {
      context.TenantRef = +route.snapshot.paramMap.get('tenantId');
    }
    if(route.snapshot.paramMap.get('tenantParentId')) {
      context.TenantParentRef = +route.snapshot.paramMap.get('tenantParentId');
    }
    if (route.snapshot.paramMap.get('clientParentId')) {
      context.UserEnteredClientParentRef = +route.snapshot.paramMap.get('clientParentId');
    }
    if (route.snapshot.paramMap.get('landlordId')) {
      context.LandlordRef = +route.snapshot.paramMap.get('landlordId');
    }
    return context;
  }

  getSupplierContextFromRoute(route: ActivatedRoute): ISupplierContext {
    let context = {} as ISupplierContext;
    if (!route?.snapshot?.paramMap)
      return context;
    if (route.snapshot.paramMap.get('accountId')) {
      context.AccountRef = +route.snapshot.paramMap.get('accountId');
    }
    return context;
  }

  getRouteContextFromRouteData(route: ActivatedRoute): RouteContext {
    return route?.snapshot?.data
      ? route.snapshot.data.routeContext as RouteContext
      : null;
  }

  getRouteContextFromRouteSnapshot(route: ActivatedRouteSnapshot): RouteContext {
    return route?.data
      ? route.data.routeContext as RouteContext
      : null;
  }

  getProductFromRouteData(route: ActivatedRoute): string {
    return route?.snapshot?.data?.product
      ? route.snapshot.data.product
      : null;
  }

  getDashboardDesignerPathFromRouteData(route: ActivatedRoute): string {
    return route?.snapshot?.data?.dashboardDesignerPath
      ? route.snapshot.data.dashboardDesignerPath
      : null;
  }

  getProfileManagerRoutePathFromRouteData(route: ActivatedRoute): string {
    return route?.snapshot?.data?.profileManagerPath
      ? route.snapshot.data.profileManagerPath
      : null;
  }
}
